import { Model } from "../mvvm/Model.js";
/**
 * LegalDocument is the OOP domain model for data-driven Terms and Privacy pages (#902).
 * Views bind to its sections rather than embedding hardcoded prose in TSX.
 */
export class LegalDocument extends Model {
    kicker;
    title;
    lead;
    sections;
    constructor(dto) {
        super();
        this.kicker = dto.kicker?.trim() || "Legal";
        this.title = dto.title?.trim() || "";
        this.lead = dto.lead?.trim() || "";
        this.sections = dto.sections ?? [];
    }
    isEmpty() {
        return this.sections.length === 0;
    }
    validate() {
        const errors = [];
        if (!this.title)
            errors.push("Legal document title is required.");
        if (this.sections.length === 0)
            errors.push("Legal document has no sections.");
        return errors;
    }
}
//# sourceMappingURL=LegalDocument.js.map